<div style="margin-top: 15px; margin-left: 2vw; padding-left: 15px">
  <h2 *ngIf="dataSource">
    Agrupaciones por país
    <button
      mat-raised-button
      color="primary"
      matBadgeColor="warn"
      [matBadge]="gatewayRaizDown"
      (click)="
        filterTable('filter', 'dataSource', 'alarmadosCount', '>', 0, $event)
      "
    >
      Mostrar puntos alarmados
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="
        filterTable('showFullTable', 'dataSource', null, null, null, null)
      "
      style="margin-left: 15px"
    >
      Mostrar tabla completa
    </button>
  </h2>
</div>

<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Buscar en la tabla..."
  />
</mat-form-field>

<div
  class="mat-elevation-z8"
  style="width: 85%"
  align="center"
  [hidden]="!dataSource"
>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="gateway">
      <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
      <td mat-cell *matCellDef="let gateway; let i = index">
        <span
          *ngIf="gateway.alarmadosCount"
          matBadge="{{ gateway.alarmadosCount }}"
          matBadgeOverlap="true"
          ><i class="material-icons alarm">new_releases</i></span
        >
        <a
          style="padding-left: 25px"
          [routerLink]="['/gateways', gateway.data.uuid]"
          title="Navegar al gateway {{ gateway.data.nombre }}"
        >
          {{ gateway.data.nombre }}
        </a>
        <i
          class="material-icons copy"
          title="Copiar el uuid del gateway {{ gateway.data.nombre }}"
          ngxClipboard
          [cbContent]="gateway.data.uuid"
          (cbOnSuccess)="copiado($event)"
        >
          file_copy
        </i>
      </td>
    </ng-container>

    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef><b>Último dato recibido</b></th>
      <td mat-cell *matCellDef="let gateway">
        {{
          (gateway.data.lastSource?.lastEntrada?.lastFecha | getDatePipe) ||
            "No existe fecha de recepción de datos"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="alarmedSources">
      <th mat-header-cell *matHeaderCellDef><b>Sources con alarmas </b></th>
      <td mat-cell *matCellDef="let gateway">
        {{ gateway.alarmadosCount }} / {{ gateway.data.sourcesTotal || 0 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="sources">
      <th mat-header-cell *matHeaderCellDef><b>Sources rezagados </b></th>
      <td mat-cell *matCellDef="let gateway">
        {{ gateway.sourcesRezagados }} / {{ gateway.data.sourcesTotal || 0 }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <!-- [ngClass]="{'trError': (row.alarmadosCount > 0), 'trWarning' : (row.silenciadosCount >0)}" -->
  </table>
  <mat-paginator
    #TableGatewayRaizPaginator="matPaginator"
    [pageSizeOptions]="[15, 30, 50]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>

<div style="margin-top: 25px; margin-left: 2vw">
  <h2 *ngIf="dataSourceConcen">
    Concentradores

    <button
      mat-raised-button
      color="primary"
      matBadgeColor="warn"
      [matBadge]="concentradoresDown"
      (click)="
        filterTable(
          'filter',
          'dataSourceConcen',
          'alive.lastEntrada.lastValor',
          '==',
          'false',
          $event
        )
      "
    >
      Mostrar puntos sin comunicación
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="
        filterTable('showFullTable', 'dataSourceConcen', null, null, null, null)
      "
      style="margin-left: 15px"
    >
      Mostrar tabla completa
    </button>
  </h2>
</div>

<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilterConcen($event)"
    placeholder="Buscar en la tabla..."
  />
</mat-form-field>

<div class="mat-elevation-z8" style="width: 85%" align="center">
  <table mat-table [dataSource]="dataSourceConcen" concenSort>
    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef><b>Nombre del Gateway</b></th>
      <td mat-cell *matCellDef="let concen; let i = index">
        <!-- <span matBadge="{{i}}" matBadgeOverlap="true"><i class="material-icons alarm">new_releases</i></span> -->
        <a
          style="padding-left: 35px"
          title="Navegar a {{ (concen.alive.tiene && concen.alive.tiene.nombre) ? concen.alive.tiene.nombre : 'sin nombre' }}"
          [routerLink]="['/gateways', concen.uuid]"
        >
          {{ (concen.alive.tiene && concen.alive.tiene.nombre) ? concen.alive.tiene.nombre : 'sin nombre' }}
        </a>
        <i
          class="material-icons copy"
          title="Copiar el uuid del concentrador {{
            (concen.alive.tiene && concen.alive.tiene.nombre) ? concen.alive.tiene.nombre :  'sin nombre'
          }}"
          ngxClipboard
          [cbContent]="concen.uuid"
          (cbOnSuccess)="copiado($event)"
        >
          file_copy
        </i>
      </td>
    </ng-container>

    <ng-container matColumnDef="host">
      <th mat-header-cell *matHeaderCellDef><b>Host del GateWay</b></th>
      <td mat-cell *matCellDef="let concen">
        {{ concen.host }}
        <i
          class="material-icons copy"
          title="Copiar el uuid del concentrador {{
            (concen.alive.tiene && concen.alive.tiene.nombre) ? concen.alive.tiene.nombre : 'sin nombre'
          }}"
          ngxClipboard
          [cbContent]="concen.host"
          (cbOnSuccess)="copiado($event)"
        >
          file_copy
        </i>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastFecha">
      <th mat-header-cell *matHeaderCellDef><b>Último intento de ping </b></th>
      <td mat-cell *matCellDef="let concen">
        {{
          concen.alive.lastEntrada && concen.alive.lastEntrada.lastValor
            ? (concen.alive.lastEntrada.lastFecha | getDatePipe)
            : "Sin última fecha registrada"
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="alive">
      <th mat-header-cell *matHeaderCellDef>
        <b> Respuesta en la comunicación </b>
      </th>
      <td mat-cell *matCellDef="let concen">
        {{
          concen.alive.lastEntrada && concen.alive.lastEntrada.lastValor
            ? concen.alive.lastEntrada.lastValor
            : "No hay valor registrado"
        }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsConcen"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumnsConcen"
      [ngClass]="{ trError: row.alive.lastEntrada.lastValor === 'false' }"
    ></tr>
  </table>
  <mat-paginator
    #TableConcenPaginator="matPaginator"
    [pageSizeOptions]="[15, 30, 50]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>

<ng-template #elseBlock>
  <i
    class="material-icons warning"
    title="Existen sources rezagados en el gateway"
  >
    warning
  </i>
</ng-template>

<br />
